import * as v from "valibot";
import { rpcContract } from "../rpc";
import { creatorMessageSchema } from "./creator-message";

export { type CreatorMessage } from "./creator-message";

export const getCreatorMessagesRpcContract = rpcContract({
  name: "get-creator-messages",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    messages: v.array(creatorMessageSchema),
    counts: v.object({
      draft: v.number(),
      scheduled: v.number(),
      sending: v.number(),
      sent: v.number(),
      failed: v.number(),
      archived: v.number(),
      total: v.number(),
    }),
  }),
});

export type GetCreatorMessagesParams = v.InferOutput<(typeof getCreatorMessagesRpcContract)["paramsSchema"]>;
export type GetCreatorMessagesResult = v.InferOutput<(typeof getCreatorMessagesRpcContract)["resultSchema"]>;
